document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".blog-posts-section").forEach((section) => {

        const track = section.querySelector(".blog-track");
        const cards = section.querySelectorAll(".blog-card");
        const prev = section.querySelector(".blog-arrow.prev");
        const next = section.querySelector(".blog-arrow.next");

        if (!track || cards.length === 0) return;

        let current = 0;
        let cardWidth = 0;
        let visible = 3;
        let maxIndex = 0;

        function updateValues() {

            if (window.innerWidth <= 767) {

                visible = 1;

            } else if (window.innerWidth <= 991) {

                visible = 2;

            } else {

                visible = 3;

            }

            cardWidth = cards[0].offsetWidth + 30;

            maxIndex = Math.max(0, cards.length - visible);

            if (current > maxIndex) {
                current = maxIndex;
            }

            move();

            if (cards.length <= visible) {

                if (prev) prev.style.display = "none";
                if (next) next.style.display = "none";

            } else {

                if (prev) prev.style.display = "flex";
                if (next) next.style.display = "flex";

            }

        }

        function move() {

            track.style.transform =
                `translateX(-${current * cardWidth}px)`;

            if (prev)
                prev.disabled = current === 0;

            if (next)
                next.disabled = current >= maxIndex;

        }

        if (next) {

            next.addEventListener("click", () => {

                if (current < maxIndex) {

                    current++;

                    move();

                }

            });

        }

        if (prev) {

            prev.addEventListener("click", () => {

                if (current > 0) {

                    current--;

                    move();

                }

            });

        }

        /*-----------------------
        Touch Swipe
        -----------------------*/

        let startX = 0;
        let endX = 0;

        track.addEventListener("touchstart", (e) => {

            startX = e.touches[0].clientX;

        });

        track.addEventListener("touchmove", (e) => {

            endX = e.touches[0].clientX;

        });

        track.addEventListener("touchend", () => {

            const distance = startX - endX;

            if (distance > 60 && current < maxIndex) {

                current++;

                move();

            }

            if (distance < -60 && current > 0) {

                current--;

                move();

            }

        });

        /*-----------------------
        Mouse Drag
        -----------------------*/

        let isDown = false;
        let dragStart = 0;
        let dragEnd = 0;

        track.addEventListener("mousedown", (e) => {

            isDown = true;

            dragStart = e.clientX;

        });

        window.addEventListener("mouseup", () => {

            if (!isDown) return;

            isDown = false;

            const distance = dragStart - dragEnd;

            if (distance > 80 && current < maxIndex) {

                current++;

            }

            if (distance < -80 && current > 0) {

                current--;

            }

            move();

        });

        track.addEventListener("mousemove", (e) => {

            if (!isDown) return;

            dragEnd = e.clientX;

        });

        /*-----------------------
        Auto Play
        -----------------------*/

        let auto = setInterval(() => {

            if (cards.length <= visible)
                return;

            if (current >= maxIndex) {

                current = 0;

            } else {

                current++;

            }

            move();

        }, 4500);

        section.addEventListener("mouseenter", () => {

            clearInterval(auto);

        });

        section.addEventListener("mouseleave", () => {

            auto = setInterval(() => {

                if (cards.length <= visible)
                    return;

                if (current >= maxIndex) {

                    current = 0;

                } else {

                    current++;

                }

                move();

            }, 4500);

        });

        window.addEventListener("resize", updateValues);

        updateValues();

    });

});